import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Pipe({
  name: 'replaceNullWithText',
  pure: false
})

export class ReplaceNullWithTextPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(value: any, replaceText?: string): any {
    let replaceLabel = '-';
    if (typeof value === 'undefined' || value === 'null' || value === null || value === undefined || value?.length === 0) {
      if (replaceText) {
        return replaceText;
      } else {
        this.translateService.stream('LABELS.UNDEFINED').subscribe(label => replaceLabel = label);
        return replaceLabel;
      }
    } else {
      return value;
    }
  }
}
